const MONTH_NAMES = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

/**
 * Gera array de 24 meses: 11 para trás + mês corrente + 12 para frente.
 * Formato: "YYYY-MM"
 */
export function generateMonthRange(): string[] {
  const now = new Date();
  const months: string[] = [];
  for (let i = -11; i <= 12; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() + i, 1);
    months.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`);
  }
  return months;
}

/** Formata "YYYY-MM" para "Mmm/AA" (ex: "2026-06" → "Jun/26") */
export function formatMonthLabel(m: string): string {
  const [y, mo] = m.split('-');
  return `${MONTH_NAMES[+mo - 1]}/${y.slice(2)}`;
}
